import React from 'react';
import * as ROUTES from '../../../constants/routes';
import PricingPersonaHero from './PricingPersonaHero';
import PricingTwoCardGrid from './PricingTwoCardGrid';
import PricingFeatureTable from './PricingFeatureTable';

const ROWS = [
    { title: '📊 Your Dashboard', freeItems: ['Portfolio dashboard', 'Workflow Manager', 'AnyList Checklist Builder', 'Client Benchmarking', 'Unaudited Certification support', 'Connect clients to investor database', 'Promotion to new clients', 'Chargeable quarterly reviews', 'Agentic & phone support'] },
    { title: '🚀 Client — Investment', paidItems: ['All Company Pro tools', 'Foundational & Value Diligence Packs', 'AnyList & ResearchAid builders', 'InvestorMatch 1-click intros (Gold cert)'] },
    { title: '📈 Client — Growth', paidItems: ['Growth Readiness Checklist', '20× Healthboost Modules', 'AppStore modules'] },
    { title: '🏁 Client — Exit', paidItems: ['Exit Readiness Checklist', 'Foundational & Value Diligence Packs', 'CF / Businesses For Sale introductions'] },
];

const PricingAdvisorsPanel = () => (
    <div role="tabpanel">
        <PricingPersonaHero
            eyebrow="For Advisors"
            dotColor="#E8820C"
            title="Free for you. Powerful for your clients."
            subtitle="Your advisor account is always free. Add client companies at a 20% discount on Pro."
            primaryCta={{ text: 'Create advisor account', href: ROUTES.REGISTER }}
            secondaryCta={{ text: 'Learn more ↓', href: '#advisors-included' }}
        />

        <PricingTwoCardGrid
            free={{ label: 'Free — Your Advisor Account', amount: '£0', sub: 'free always', text: 'Your full dashboard and portfolio management tools.', cta: { text: 'Get started free', href: ROUTES.REGISTER } }}
            paid={{ label: 'Portfolio Pro', amount: '£66.67', sub: '/ mo · £800/yr · code ADVISOR20', text: 'Give every client the full Pro toolkit across Investment, Growth & Exit.', badge: 'Per client company', cta: { text: 'Add a client', href: ROUTES.REGISTER } }}
        />

        <div id="advisors-included">
            <PricingFeatureTable
                freeColLabel="Free — you"
                paidColLabel="Portfolio Pro / client"
                freeSummary="All free tools + full Company Pro per client"
                rows={ROWS}
                footnote="* Portfolio Pro (£800/yr per client) via your dashboard. Code ADVISOR20 at checkout."
            />
        </div>
    </div>
);

export default PricingAdvisorsPanel;
